import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const VisitorMetrics = ({ data, title }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-conservation">
          <p className="text-sm font-medium text-gray-900 dark:text-white mb-2">{payload?.[0]?.payload?.name}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-sm text-gray-600 dark:text-gray-300">
              {entry?.name}: <span className="font-medium text-gray-900 dark:text-white">{entry?.value}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">{title}</h3>
      <div className="w-full h-80" aria-label={title}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="name" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px', color: 'var(--color-muted-foreground)' }}
            />
            <Bar dataKey="visitors" fill="var(--color-primary)" radius={[4, 4, 0, 0]} />
            <Bar dataKey="permits" fill="var(--color-secondary)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default VisitorMetrics;